<p>

  <mat-card appearance="outlined" style="width:50%; margin:auto;">
      <mat-card-title class="shorten-long-text"></mat-card-title>
      <mat-card-content>
        <span>{{ OBJ_LNG_NAME+'.text' | translate:locale.language }}</span>
        <p *ngIf="disableImport">{{ OBJ_LNG_NAME+'.laeuft' | translate:locale.language }}</p>
      </mat-card-content>
      <mat-card-actions align="end">
        <button mat-raised-button (click)="importiereDateien();" style="margin-left:200px;" [disabled]="laeuftImport()">{{ OBJ_LNG_NAME+'.import' | translate:locale.language }}</button>
      </mat-card-actions>
    </mat-card>
</p>
